const production = {
  baseUrl: 'https://api.100ladrillos.com/marketplace',
  port: 0,
  mapsApiKey: process.env.GOOGLE_MAPS_API_KEY
};

const staging = {
  baseUrl: 'https://api-staging.100ladrillos.com/marketplace',
  port: 0,
  mapsApiKey: process.env.GOOGLE_MAPS_API_KEY
};

const development = {
  baseUrl: 'https://api-dev.100ladrillos.com/marketplace',
  port: 0,
  mapsApiKey: process.env.GOOGLE_MAPS_API_KEY
};

const local = {
  baseUrl: 'http://localhost',
  port: 9000,
  mapsApiKey: ''
};

const test = {
  baseUrl: 'http://localhost',
  port: 9000,
  mapsApiKey: ''
};

const config = {
  development,
  production,
  staging,
  test,
  local
};

export default config;
